import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CiiBadgeComponent } from '../../../components/cii-badge/cii-badge.component';

@Component({
  selector: 'app-node-rescue',
  standalone: true,
  imports: [CiiBadgeComponent],
  templateUrl: './node-rescue.component.html',
  styleUrl: './node-rescue.component.css'
})
export class NodeRescueComponent implements OnInit {

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Sauvetage & Audit Urgent Node.js : Intervention Critique sous 24h — Expert CII");
    this.metaService.updateTag({ name: 'description', content: "Votre application Node.js plante ? Crashs, fuites de mémoire ou lenteurs : nos experts seniors interviennent immédiatement pour stabiliser votre production. Audit et réparation express." });
  }
}